// extracted by mini-css-extract-plugin
export default {"container":"PageContainerWithBackground_container__Yr8Ae"};